import React from 'react';
import '../style.sass';
import styles from "../ModulosPagarPlanes/pagarPlan.module.sass"

import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import { MenuCredito } from 'components/menuCredito'
import ModalPortal from 'components/Modal'
import { ModalMontoMinimo } from '../../7-Modals'
import { ContentSinglePlans } from '../ModulosPagarPlanes'


export default function PagarTarjetaMovil(props) {

    const {
        singlePlanData,
        completePlanData,
        isMobile,
        verModalMontoMinimo,
        paySimplePlan,
        cerrarModalMontoMinimo
    } = props

    return (
        <>
            <Header type="complete" />

            <div className={"container"}>
                <div className="contPlanPayments">
                    <MenuCredito />

                    <div className="contPlanes">
        
                        <div>
    
                            <h2 className='h2'>Pagar</h2>
                            
                            <h2 className={"h4"}>Selecciona el monto a pagar</h2>

                            <ContentSinglePlans isMobile={isMobile} singlePlanData={singlePlanData} />

                            <div className={"contButton"}>
                                <button className="btn rojo" onClick={paySimplePlan}>Continuar al pago</button>
                            </div>
                        </div>

                        {verModalMontoMinimo === true &&
                            <ModalPortal type="sinClose" onClose={cerrarModalMontoMinimo} >
                                <ModalMontoMinimo onClose={cerrarModalMontoMinimo}
                                    type="" title="" remvoeAction={cerrarModalMontoMinimo} body={"No podemos continuar, la cantidad mínima para realizar un pago es de $1.00"} subtitulo={"¡Lo sentimos!"}
                                />
                            </ModalPortal>
                        }
                    </div>

                </div>
            </div>

            <Footer type="complete" />
        </>
    )
}